// import logo from './logo.svg';
import './App.css';
// import lindbergVideo from './assets/video/lindberg-front.mp4';
import React, {useState, useEffect}  from 'react';
import bestsellerVideo from './assets/video/bestseller-ipad.mp4';
import kleemannVideo from './assets/video/kleemann.mp4';
import ipad from './assets/images/iPad-portrait.png';
import ProjectCarousel from './js/ProjectCarousel.js';
// import ipad2 from './assets/images/iPad-landscape.png';

function App() {

  const [activeProjectId, setActiveProjectId] = useState(1);
  useEffect(() => {
    setCurrentProjectTitle(projectTitles[activeProjectId-1]);
  }, [activeProjectId]);

  const [scaleRatio, setScaleRatio] = useState(1);
  useEffect(() => {
    setContentWidth(1920 * scaleRatio);
    setContentHeight(1080 * scaleRatio);
  }, [scaleRatio]);

  const [isPortrait, setIsPortrait] = useState(false);
  const [contentWidth, setContentWidth] = useState(0);
  const [contentHeight, setContentHeight] = useState(0);
  const [currentProjectTitle, setCurrentProjectTitle] = useState("CaptionFlow");
  
  let projectTitles = ["CaptionFlow", "Kleemann", "Bestseller"];

  useEffect(() => {
    window.addEventListener('resize', windowResized);
    windowResized();
  }, []);

  const windowResized = () => {
    console.log(window.innerWidth + 'x' + window.innerHeight);
    if(window.innerWidth > window.innerHeight){
      setIsPortrait(false);
      if(1920 * (window.innerHeight - 250) / 1080 > window.innerWidth - 200){
        setScaleRatio((window.innerWidth - 250) / 1920);
        // setScaleRatio((window.innerHeight - 250) / 1080);
      } else {
        setScaleRatio((window.innerHeight - 250) / 1080);
      }
    } else {
      setIsPortrait(true);
      console.error(1080 * (window.innerWidth - 80) / 1920);
      setScaleRatio((window.innerWidth - 80) / 1920);
    }
  }

  const nextHit = () => {
    if(activeProjectId === projectTitles.length ? setActiveProjectId(1) : setActiveProjectId(activeProjectId + 1));
  }

  const prevHit = () => {
    if(activeProjectId === 1 ? setActiveProjectId(projectTitles.length) : setActiveProjectId(activeProjectId - 1));
  }

  return (
    <div className="App">
      {/* background image */}
      {/* <div className="bg-red-500 w-full rounded-3xl h-[400px] bg-no-repeat bg-right" style={{backgroundSize: 'cover', backgroundImage: 'url("https://cdn.lindberg.com/media/bzbj03ky/p_f2486_703_pgt-ed-gc02_c.jpg?format=webp&width=3840&height=3840&mode=min")'}}></div> */}
      <main className="flex min-h-screen flex-col">
        <div id="persona" className="flex flex-col my-8">
          <label className="text-2xl font-bold">Lucas Brendan Ward</label>
          <label>Designer & Developer</label>
        </div>
        <div className="flex h-full items-center justify-center">
          <ProjectCarousel contentWidth={contentWidth} contentHeight={contentHeight} />
        </div>
        {/* <div id="captionflow" className="flex flex-col items-center">
          <label className="font-bold text-2xl">CaptionFlow</label>
          <p>An online editor for creating or adjusting captions on<br/>your videos as quick and easy as possible.</p>
          <div className="max-h-[30vh]">
            <video className="object-container rounded-3xl border-[#E0E0E0] lg:shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)]" autoPlay loop muted>
              <source src={captionflowVideo} />
            </video>
          </div>
        </div> */}
        {/* COLLAGE */}
        {/* <div className="grid w-full h-[600px] lg:grid-cols-[60%_minmax(40%,_1fr)_100%] lg:gap-5">
          <div className="grid flex-1 lg:grid-rows-1 lg:gap-6">
            <div id="captionflow">
              <div className="text-left px-4 pb-4">
                <label className="font-bold text-2xl">CaptionFlow</label>
                <p>An online editor for creating or adjusting captions on<br/>your videos as quick and easy as possible.</p>
              </div>
              <div className="relative pt-[56.25%] h-0">
                <video className="rounded-3xl absolute top-0 left-0 h-full w-full border-[#E0E0E0] lg:shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)]" autoPlay loop muted>
                  <source src={captionflowVideo} />
                </video>
              </div>
            </div>
            <div id="kleemann" className="">
              <div>
                <div className="text-left px-4 pb-4">
                  <label className="font-bold text-2xl">Kleemann</label>
                  <p>Customize your Mercedes in this interactive application for a tuning company.</p>
                </div>
                <div className="relative">
                  <div className="absolute top-[1.9%] left-[0.3%] scale-[91%]">
                    <video autoPlay loop muted>
                      <source src={kleemannVideo} />
                    </video>
                  </div>
                  <div className="">
                    <div className="ipad-bg-wrapper" style={{paddingTop: '77%'}}><div className="shadow w-full h-full absolute top-0 left-0 lg:shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] rounded-[50px]"></div><div className="ipad-bg-content" style={{backgroundSize: 'cover', backgroundImage: `url(${ipad2})`}}></div></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="text-left px-4 pb-4">
              <label className="font-bold text-2xl">Bestseller</label>
              <p>360 measurement tool.</p>
            </div>
            <div id="bestseller" className="">
              <div className="relative">
                <div className="absolute top-[-1.65%] left-[-0.3%] scale-[87.6%]">
                  <video autoPlay loop muted>
                    <source src={bestsellerVideo} />
                  </video>
                </div>
                <div className="">
                  <div className="ipad-bg-wrapper" style={{paddingTop: '129.0%'}}><div className="shadow w-full h-full absolute top-0 left-0 lg:shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] rounded-[50px]"></div><div className="ipad-bg-content" style={{backgroundSize: 'cover', backgroundImage: `url(${ipad})`}}></div></div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </main>
    </div>
  );
}

export default App;
